const FACES = {
  0: { day: ["☀️", "Ensoleillé"], night: ["🌙", "Nuit claire"] },
  1: { day: ["🌤️", "Éclaircies"], night: ["🌙", "Nuit claire"] },
  2: { day: ["🌤️", "Partiellement nuageux"], night: ["☁️🌙", "Nuit nuageuse"] },
  3: { day: ["☁️", "Nuageux"], night: ["☁️🌙", "Nuit nuageuse"] },
};

export function weatherFace(code, night = false) {
  if (code === null || code === undefined || code === "") return { icon: "", label: "Condition non reçue" };
  const value = Number(code);
  if (!Number.isFinite(value)) return { icon: "", label: "Condition non reçue" };
  const known = FACES[value];
  if (known) {
    const [icon, label] = night ? known.night : known.day;
    return { icon, label };
  }
  if (value === 45 || value === 48) return { icon: "🌫️", label: "Brouillard" };
  if (value >= 51 && value <= 57) return { icon: "🌦️", label: "Bruine" };
  if (value >= 80 && value <= 82) return { icon: "🌦️", label: "Averses" };
  if (value >= 61 && value <= 67) return { icon: "🌧️", label: "Pluie" };
  if (value >= 71 && value <= 77) return { icon: "❄️", label: "Neige" };
  if (value >= 95) return { icon: "⛈️", label: "Orage" };
  return { icon: "", label: "Condition non reçue" };
}

const WIND = { N: "N", NE: "NE", E: "E", SE: "SE", S: "S", SW: "SO", W: "O", NW: "NO" };
const WIND_WORDS = {
  N: "nord", NE: "nord-est", E: "est", SE: "sud-est", S: "sud",
  SO: "sud-ouest", SW: "sud-ouest", O: "ouest", W: "ouest", NO: "nord-ouest", NW: "nord-ouest",
};

export function windFr(dir) {
  return WIND[dir] || dir || "—";
}

export function windSentence(dir, speed) {
  let key = windFr(dir);
  if (!WIND_WORDS[key]) {
    const degrees = Number(dir);
    if (Number.isFinite(degrees)) {
      const labels = ["N", "NE", "E", "SE", "S", "SO", "O", "NO"];
      key = labels[Math.round((((degrees % 360) + 360) % 360) / 45) % 8];
    }
  }
  const word = WIND_WORDS[key] || "direction inconnue";
  const number = Number(speed);
  const km = Number.isFinite(number) ? `${Math.round(number)} km/h` : "";
  return km ? `Vent ${word}, ${km}` : `Vent ${word}`;
}

export function rainWords(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "pluie non reçue";
  const percent = Math.round(number);
  if (percent <= 0) return "pas de pluie";
  if (percent < 30) return `peu de pluie (${percent} %)`;
  if (percent < 70) return `pluie possible (${percent} %)`;
  return `pluie prévue (${percent} %)`;
}
